import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-541249d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "brushes" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "35",
  height: "37",
  viewBox: "0 0 35 37",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M22.5001 8C27.5002 14.5 31.0002 29 17 16.5C16.1667 15.8333 14.6 15.1 15 17.5C15.5 20.5 15.5 26.5 8.00002 29",
    stroke: "currentColor",
    "stroke-width": "1.4",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "36",
  height: "37",
  viewBox: "0 0 36 37",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M23.3953 8C28.3954 14.5 31.8954 29 17.8952 16.5C17.0619 15.8333 15.4952 15.1 15.8952 17.5C16.3952 20.5 16.3952 26.5 8.89522 29",
    stroke: "currentColor",
    "stroke-width": "2.4",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "36",
  height: "37",
  viewBox: "0 0 36 37",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M23.2905 8C28.2905 14.5 31.7905 29 17.7903 16.5C16.957 15.8333 15.3904 15.1 15.7904 17.5C16.2904 20.5 16.2904 26.5 8.79036 29",
    stroke: "currentColor",
    "stroke-width": "4.4",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "36",
  height: "37",
  viewBox: "0 0 36 37",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M23.1856 8C28.1857 14.5 31.6857 29 17.6855 16.5C16.8521 15.8333 15.2855 15.1 15.6855 17.5C16.1855 20.5 16.1855 26.5 8.6855 29",
    stroke: "currentColor",
    "stroke-width": "5.4",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "36",
  height: "37",
  viewBox: "0 0 36 37",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M23.0808 8C28.0808 14.5 31.5808 29 17.5806 16.5C16.7473 15.8333 15.1806 15.1 15.5806 17.5C16.0806 20.5 16.0806 26.5 8.58064 29",
    stroke: "currentColor",
    "stroke-width": "8.4",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["brush lighter", { active: _ctx.lineWidth_ == 3 }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.paint._lineWidth = 3))
    }, _hoisted_3, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["brush light", { active: _ctx.lineWidth_ == 5 }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.paint._lineWidth = 5))
    }, _hoisted_5, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["brush normal", { active: _ctx.lineWidth_ == 10 }]),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.paint._lineWidth = 10))
    }, _hoisted_7, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["brush bold", { active: _ctx.lineWidth_ == 15 }]),
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.paint._lineWidth = 15))
    }, _hoisted_9, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["brush bolder", { active: _ctx.lineWidth_ == 20 }]),
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.paint._lineWidth = 20))
    }, _hoisted_11, 2)
  ]))
}